import { SipRecommendationActionType } from '../../api/common.types'
import type { SipYourPlanListFund } from '../../api/sipPlan.types'
import { SipCategoryBucketKey } from '../../api/types'

export type IdealSipPlanRecommendationOpenParams = {
  isin: string
  totalIdealSipAmount: number
}

export type SipPlanRecommendationSheetContext = {
  recommendation: SipYourPlanListFund
  initiateSipCta?: unknown
  manageSipCta?: unknown
}

export type SipPlanRecommendationOpenParams = {
  isin: string
  totalIdealSipAmount: number
  bucketType?: SipCategoryBucketKey
  recommendationAction?: SipRecommendationActionType
} & SipPlanRecommendationSheetContext

export type SipPlanRecommendationContainerInput = {
  onDismiss: () => void
  isin: string
  totalIdealSipAmount: number
} & SipPlanRecommendationSheetContext

const SIP_PLAN_RECOMMENDATION_BOTTOM_SHEET_BUCKET_KEYS = new Set<SipCategoryBucketKey>([
  SipCategoryBucketKey.stopRecommendations,
  SipCategoryBucketKey.startRecommendations,
  SipCategoryBucketKey.increaseRecommendations,
  SipCategoryBucketKey.decreaseRecommendations
])

export function isSipPlanRecommendationBottomSheetBucket(
  bucketType?: SipCategoryBucketKey
): bucketType is SipCategoryBucketKey {
  return bucketType != null && SIP_PLAN_RECOMMENDATION_BOTTOM_SHEET_BUCKET_KEYS.has(bucketType)
}

export function resolveSipRecommendationAction(
  bucketType?: SipCategoryBucketKey,
  recommendationAction?: SipRecommendationActionType
): SipRecommendationActionType | undefined {
  if (recommendationAction) {
    return recommendationAction
  }
  if (bucketType === SipCategoryBucketKey.startRecommendations) {
    return SipRecommendationActionType.START
  }
  if (bucketType === SipCategoryBucketKey.stopRecommendations) {
    return SipRecommendationActionType.STOP
  }
  if (bucketType === SipCategoryBucketKey.increaseRecommendations) {
    return SipRecommendationActionType.INCREASE
  }
  if (bucketType === SipCategoryBucketKey.decreaseRecommendations) {
    return SipRecommendationActionType.DECREASE
  }
  return undefined
}
